(function () {
  /**
   * @ngdoc service/provider
   * @name jilResellerInvitations
   * @description defines service to manage jil reseller invitation resources
   */
  angular.module('app.core.api.jil').provider('jilResellerInvitations', provider);

  let url;

  /* @ngInject */
  function provider() {
    this.configure = configure;
    this.$get = $get;

    ////////////

    function configure(config) {
      url = `${config.url}/v2/resellers`;
    }

    /* @ngInject */
    function $get($resource) {
      const service = {
        resellerInvitations: getResellerInvitationsResource(),
      };

      return service;

      ///////////

      function getResellerInvitationsResource() {
        return $resource(
          `${url}/:resellerId/invitation`,
          {
            resellerId: '@resellerId',
          },
          {
            update: {
              method: 'PUT',
            },
          }
        );
      }
    }
  }
})();
